export const PRODUCTS_OF_PROVIDER_TTL_ES = 'Productos del proveedor';

export interface IProductOfProviderBase {
  providerId: number;
  providerName: string;
  unitMeasureDescription: string;
  code: string;
  description: string;
  providerRuc: string;
  unitMeasureSymbol: string;
  typeProductId: number;
  producRegulatedId: number | null;
  productUnregulatedId: number | null;
}

export interface IProductOfProvider extends IProductOfProviderBase {
  id: number;
}

export type IProductOfProviderUpdate = Partial<IProductOfProviderBase>;
